import "./styles/main.css";
import { registerPlugins } from "./plugins";
import App from "./App.vue";
import { createApp } from "vue";
import "./util/dayjs";
import "@mdi/font/css/materialdesignicons.css";

const app = createApp(App);

registerPlugins(app).then(() => app.mount("#app"));
